import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes, letting later ones win.
 *
 * `clsx` handles conditionals; `twMerge` resolves conflicts. Without the
 * second, `cn('p-2', 'p-4')` emits both and which one applies depends on the
 * order Tailwind happened to generate them in — a bug that looks like a
 * caching problem.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
